import { render, staticRenderFns } from "./createLinks.vue?vue&type=template&id=57bc13ed&"
import script from "./createLinks.vue?vue&type=script&lang=js&"
export * from "./createLinks.vue?vue&type=script&lang=js&"
import style0 from "./createLinks.vue?vue&type=style&index=0&id=57bc13ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports